export type GitLogEntry = {
  hash: string;
  date: string;
  author: string;
  subject: string;
  refs: string;
};
export function parseGitLog(output: string): GitLogEntry[] {
  return output
    .split(/\r?\n/)
    .filter(Boolean)
    .map((row) => {
      const [hash = "", date = "", author = "", subject = "", refs = ""] =
        row.split("\t");
      return { hash, date, author, subject, refs };
    })
    .filter((entry) => entry.hash && entry.subject);
}
